import React from 'react';
import { DATE_TIME_FORMAT } from '../../api/api.types';
import { PriceCalculatorCacheStatus, UpdateStatus } from '../../api/pricing/pricing.types';
import done from '../../assets/img/completed.svg';
import updating from '../../assets/img/refreshing.svg';
import publish from '../../assets/img/publish.svg';
import { getTimeBeforePublish } from '../../helpers/timeHelper';
import dayjs from 'dayjs';
import {WithTranslation, withTranslation} from 'react-i18next';

interface CacheStatusLabelProps extends WithTranslation {
  status: PriceCalculatorCacheStatus;
  canPublish?: boolean;
  onPublish: () => void;
}

class CacheStatusLabel extends React.PureComponent<CacheStatusLabelProps> {

  getContent = () => {
      const { t } = this.props;

    if (this.props.status.updateStatus === UpdateStatus.UPDATE_IN_PROGRESS) {
      return (
        <div className="d-flex align-items-center row mr-1">
          <div className="mr-2">
            <img alt="done" className="logo" src={updating}></img>
          </div>
          <div className="d-flex flex-column">
            <label className="text-warning filter-label">{t('components.cache_status_label.publishing_changes')}</label>
            <div className="info-text">{t('components.cache_status_label.can_take_10_min')}</div>
          </div>
        </div>
      );
    }

    if (this.props.canPublish) {
      return (
        <div className="d-flex align-items-center row mr-1">
          <div className="mr-2">
            <img alt="done" className="logo" src={publish}></img>
          </div>
          <div className="d-flex flex-column">
            <label className="text-danger filter-label">{t('components.cache_status_label.publishing_changes')}</label>
            <div className="d-flex align-items-center">
              <div className="info-text">{t('components.cache_status_label.automatic_publish_in',
                  { minutes: getTimeBeforePublish()})}</div>
              <button className="btn btn-text-only ml-1"
                      onClick={() => this.props.onPublish()} type="button">
                  {t('components.cache_status_label.publish_now')}</button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="d-flex align-items-center row mr-1">
        <div className="mr-2">
          <img alt="done" className="logo" src={done}></img>
        </div>
        <div className="d-flex flex-column">
          <label className="text-success filter-label">{t('components.cache_status_label.all_rates_up_to_date')}
          </label>
          <div className="info-text">{t('components.cache_status_label.last_updated', {
              time: dayjs(this.props.status.lastUpdate).format(DATE_TIME_FORMAT)})}</div>
        </div>
      </div>
    );
  };

  render() {
    return this.getContent();
  }
}

export default withTranslation()(CacheStatusLabel);
